'use client';

import { c as _c } from "react/compiler-runtime";
import { formatForDisplay } from '@repo/shortcuts';
import { useAdminCmdK } from '@repo/shortcuts/admin';
import { Button, buttonVariants, Kbd, KbdGroup, SiteHeader, Tooltip, TooltipContent, TooltipTrigger } from '@repo/ui/components';
import { useHasHydrated } from '@repo/ui/hooks';
import { Plus, Search } from '@repo/ui/icons';
import Link from 'next/link';
import { useQuickCreateLoad } from './load-quick-create/quick-create-load-host.tsx';
import { useLoadCreationAccess } from '@/app/@protected/loads/_utils/use-load-creation-access.ts';
export const AppSiteHeader = () => {
  const $ = _c(19);
  const {
    open
  } = useAdminCmdK();
  const {
    canOpenNewPage,
    canQuickCreate
  } = useLoadCreationAccess();
  const modifierKey = formatForDisplay("Mod", useHasHydrated() ? undefined : {
    platform: "linux"
  });
  let t0;
  if ($[0] !== canOpenNewPage || $[1] !== canQuickCreate) {
    t0 = <LoadHeaderAction canOpenNewPage={canOpenNewPage} canQuickCreate={canQuickCreate} data-sentry-element="LoadHeaderAction" data-sentry-source-file="app-site-header.tsx" />;
    $[0] = canOpenNewPage;
    $[1] = canQuickCreate;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== open) {
    t1 = <Button aria-label="Open command palette" onClick={open} size="icon" type="button" variant="ghost" />;
    $[3] = open;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Search className="size-4" data-sentry-element="Search" data-sentry-source-file="app-site-header.tsx" />;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t1) {
    t3 = <TooltipTrigger render={t1} data-sentry-element="TooltipTrigger" data-sentry-source-file="app-site-header.tsx">{t2}</TooltipTrigger>;
    $[6] = t1;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== modifierKey) {
    t4 = <Kbd data-sentry-element="Kbd" data-sentry-source-file="app-site-header.tsx">{modifierKey}</Kbd>;
    $[8] = modifierKey;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Kbd data-sentry-element="Kbd" data-sentry-source-file="app-site-header.tsx">K</Kbd>;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t4) {
    t6 = <TooltipContent data-sentry-element="TooltipContent" data-sentry-source-file="app-site-header.tsx">Search and commands<KbdGroup data-sentry-element="KbdGroup" data-sentry-source-file="app-site-header.tsx">{t4}{t5}</KbdGroup></TooltipContent>;
    $[11] = t4;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t3 || $[14] !== t6) {
    t7 = <Tooltip data-sentry-element="Tooltip" data-sentry-source-file="app-site-header.tsx">{t3}{t6}</Tooltip>;
    $[13] = t3;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t0 || $[17] !== t7) {
    t8 = <SiteHeader data-sentry-element="SiteHeader" data-sentry-component="AppSiteHeader" data-sentry-source-file="app-site-header.tsx"><div className="ml-auto flex items-center gap-2">{t0}{t7}</div></SiteHeader>;
    $[16] = t0;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  return t8;
};
const LoadHeaderAction = t0 => {
  const $ = _c(2);
  const {
    canOpenNewPage,
    canQuickCreate
  } = t0;
  if (canQuickCreate) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <QuickCreateLoadHeaderButton />;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  if (canOpenNewPage) {
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <NewLoadHeaderButton />;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  return null;
};
const NewLoadHeaderButton = () => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Link className={buttonVariants()} href="/loads/new" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <TooltipTrigger render={t0} data-sentry-element="TooltipTrigger" data-sentry-source-file="app-site-header.tsx"><Plus data-icon="inline-start" data-sentry-element="Plus" data-sentry-source-file="app-site-header.tsx" />New draft</TooltipTrigger>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Tooltip data-sentry-element="Tooltip" data-sentry-component="NewLoadHeaderButton" data-sentry-source-file="app-site-header.tsx">{t1}<TooltipContent data-sentry-element="TooltipContent" data-sentry-source-file="app-site-header.tsx">Create a new draft<KbdGroup data-sentry-element="KbdGroup" data-sentry-source-file="app-site-header.tsx"><Kbd data-sentry-element="Kbd" data-sentry-source-file="app-site-header.tsx">N</Kbd><Kbd data-sentry-element="Kbd" data-sentry-source-file="app-site-header.tsx">L</Kbd></KbdGroup></TooltipContent></Tooltip>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
const QuickCreateLoadHeaderButton = () => {
  const $ = _c(4);
  const {
    open
  } = useQuickCreateLoad();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Plus data-icon="inline-start" data-sentry-element="Plus" data-sentry-source-file="app-site-header.tsx" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Kbd data-sentry-element="Kbd" data-sentry-source-file="app-site-header.tsx">C</Kbd>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== open) {
    t2 = <Button aria-label="Create new load" onClick={open} type="button" data-sentry-element="Button" data-sentry-component="QuickCreateLoadHeaderButton" data-sentry-source-file="app-site-header.tsx">{t0}New load{t1}</Button>;
    $[2] = open;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};